import { render } from "./ContentGridSelect.vue?vue&type=template&id=16a80504"
import script from "./ContentGridSelect.vue?vue&type=script&lang=js"
export * from "./ContentGridSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__